import React from "react";

const LineHeader = (props) => {
  if (!props.show_title) {
    return null
  }

  return (
    <div className="dashboard-line-header">
      <p className="dashboard-line-header-title">{props.title}</p>
    </div>
  )
}

export default React.memo(LineHeader);
